import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Views } from 'src/app/pages/views';
import { LocalStorageUtil } from 'src/app/util/local-storage-util';

import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

import { MSG } from '../util/constants';
import { LoginService } from './login.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  className = '';
  constructor(private snack: MatSnackBar, private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const customHeaders = this.getHeaders(request.url);

    // Merge headers originais com customHeaders
    const headers = request.headers.keys().reduce((acc, key) => {
      acc = acc.set(key, request.headers.get(key)!);
      return acc;
    }, customHeaders);

    const clonedRequest = request.clone({ headers });

    return next.handle(clonedRequest).pipe(
      retry(0),
      catchError((error: HttpErrorResponse) => {
        if (!this.shouldRedirect(error, request)) {
          return throwError(error);
        }

        this.logoutAndRedirect();
        return throwError(error.error.message || error.statusText);
      })
    );
  }

  private shouldRedirect(error, request) {
    const isForbidden = error.status === 401 || error.status === 403;
    const isLogin =
      request.url == '/login' ||
      request.url.match('isModal=true') ||
      !request.url.match('check?token=');
    return isForbidden && !isLogin;
  }

  private logoutAndRedirect() {
    LocalStorageUtil.logout();
    this.snack.open(MSG.LOGIN.LOGIN_EXPIRED, '', {
      duration: 5000,
      panelClass: this.className,
    });
    window.location.href = '/login' + window.location.search;
  }

  private getHeaders(url) {
    if (url.indexOf('slack') !== -1) {
      return new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      });
    }

    const headersObj: Record<string, string> = {};

    if (url.indexOf('upload') == -1) {
      headersObj['Content-Type'] = 'application/json';
    }

    const isIdpTokenRequest = url.indexOf('/api/auth/token') !== -1;
    if (
      !isIdpTokenRequest &&
      !url.includes(['/login', '/cadastro']) &&
      !url.includes(['/user-public'])
    ) {
      headersObj.Authorization = 'Bearer ' + LocalStorageUtil.getToken();
      if (LocalStorageUtil.getAuthProvider() === 'keycloak') {
        headersObj['X-Auth-Provider'] = 'keycloak';
      }
    }
    return new HttpHeaders(headersObj);
  }
}
